import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";

const TrialPeriodTable = ({ extendDate }) => {
  const currentStart = moment();
  const currentEnd = moment().add(1, "M");

  return (
    <TableContainer
      component={Paper}
      sx={{ maxWidth: 600, margin: "auto", mt: 1 }}
    >
      <Table aria-label="trial period table">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
            >
              Trial Period Information
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>
              Previous Trial Period
            </TableCell>
            <TableCell>
              {moment(extendDate.start_time).format("lll")} -{" "}
              {moment(extendDate.end_time).format("lll")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>New Trial Period</TableCell>
            <TableCell>
              {currentStart.format("lll")} - {currentEnd.format("lll")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TrialPeriodTable;
